import { FunctionComponent } from "react";

import {
  Theme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";

import logger from "../../logger";
import { useTranslation } from "react-i18next";

const logInfo = logger.info("connect-to-bluetooth.dialog.component");

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      maxWidth: 800,
    },
    dialogActions: {},
    formControl: {
      marginLeft: 0,
    },
    button: {
      width: 150,
      margin: theme.spacing(2),
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
  })
);

export interface ConnectedDispatch {
  requestBluetoothDevice: () => void;
}

interface Props extends ConnectedDispatch {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const ConnectToBluetoothDialogComponent: FunctionComponent<Props> = props => {
  const { open, setOpen, requestBluetoothDevice } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClose = (tryConnect: boolean) => {
    logInfo("Should try to connect ", tryConnect);

    if (tryConnect) {
      requestBluetoothDevice();
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      fullWidth={true}
      PaperProps={{ className: classes.dialog }}
      data-cy="connect-dialog"
    >
      <DialogTitle>{t("MODAL.CONNECT_TO_BLUETOOTH.TITLE")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("MODAL.CONNECT_TO_BLUETOOTH.TEXT")}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <span>
          <Button
            onClick={() => handleClose(true)}
            className={classes.button}
            variant="contained"
            data-cy="ja"
          >
            {t("COMMON.JA")}
          </Button>
          <Button
            onClick={() => handleClose(false)}
            className={classes.button}
            variant="contained"
            data-cy="nein"
          >
            {t("COMMON.NEIN")}
          </Button>
        </span>
      </DialogActions>
    </Dialog>
  );
};

export default ConnectToBluetoothDialogComponent;
